import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "styles/global-style";
import theme from "styles/theme";
import Home from "./pages/Home";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Home />
    </ThemeProvider>
  );
}

export default App;
